import React, { useEffect, useState } from 'react';
import './Dashboard.css';
import { Row, Col, Card, Form } from 'react-bootstrap';
import { BsClockHistory } from "react-icons/bs";
import SoloChecadasEmpleado from '../Catalogos/CatalogosReloj/SoloChecadasEmpleado';

export default function Dashboard() {
  const [userName, setUserName] = useState<string>(() => localStorage.getItem('User') || 'Usuario');
  const [greeting, setGreeting] = useState("");
  const [greetingIcons, setGreetingIcons] = useState<string[]>([]);
  
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date().toLocaleDateString('en-CA'));

  const numEmpleadoStored = localStorage.getItem('numEmpleado')?.replace(/['"]+/g, '') || "";

  useEffect(() => {
    const updateGreeting = () => {
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 12) { setGreeting("☀️ Buenos días"); setGreetingIcons(["🌞", "🌅", "☀️"]); }
      else if (hour >= 12 && hour < 19) { setGreeting("🌤️ Buenas tardes"); setGreetingIcons(["⛅", "🌤️", "🌞"]); }
      else { setGreeting("🌙 Buenas noches"); setGreetingIcons(["🌙", "⭐", "🌜"]); }
    };
    updateGreeting();
  }, []);

  const releaseIcons = () => {
    const container = document.createElement("div");
    container.className = "floating-icons-container";
    for (let i = 0; i < 80; i++) {
      const icon = document.createElement("span");
      icon.className = "floating-icon";
      icon.textContent = greetingIcons[Math.floor(Math.random() * greetingIcons.length)];
      icon.style.left = "50%"; icon.style.top = "50%";
      const angle = Math.random() * 360;
      const distance = 200 + Math.random() * 300;
      const dx = Math.cos(angle) * distance;
      const dy = Math.sin(angle) * distance;
      icon.style.setProperty("--dx", `${dx}px`);
      icon.style.setProperty("--dy", `${dy}px`);
      icon.style.animationDelay = Math.random() * 0.3 + "s";
      container.appendChild(icon);
    }
    document.body.appendChild(container);
    setTimeout(() => { container.remove(); }, 2500);
  };

  return (
    <div className="dashboard-layout p-4">
      <Row className="align-items-start">
        {/* LADO IZQUIERDA: SALUDO */}
        <Col xs={12} md={5}>
          <div className="dashboard-card" onClick={releaseIcons} style={{ maxWidth: '280px', cursor: 'pointer' }}>
            <div className="greeting-header">
              <span className="greeting-icon">👋</span>
              <h2 className="greeting-text">{greeting}</h2>
            </div>
          </div>
        </Col>

        {/* LADO DERECHA: TABLA CON FILTRO DE FECHA */}
        <Col xs={12} md={7} className="d-flex justify-content-end">
          {numEmpleadoStored && (
            <Card className="border-0 shadow-sm rounded-4 overflow-hidden" style={{ width: '420px', background: '#fff' }}>
              <div className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-white">
                <small className="fw-bold text-primary">
                  <BsClockHistory className="me-1" /> MIS ENTRADAS / SALIDAS
                </small>
                {/* SELECTOR DE FECHA COMPACTO */}
                <Form.Control 
                  type="date" 
                  size="sm" 
                  value={fechaSeleccionada} 
                  onChange={(e) => setFechaSeleccionada(e.target.value)}
                  style={{ width: '130px', fontSize: '11px', height: '25px' }}
                />
              </div>
              <Card.Body className="p-0">
                <SoloChecadasEmpleado 
                    empleadoFiltro={numEmpleadoStored} 
                    fechaFiltro={fechaSeleccionada} 
                />
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
}